module.exports = __webpack_public_path__ + "static/media/objects_02.b5c07272.svg";